import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import PinModal from "components/__new/common/PinModal";
import { toast } from "react-toastify";
import Maybe from "components/__new/common/Maybe";
import useLoginInfo from "hooks/useLoginInfo";
import ModalAlert from "components/__new/common/ModalAlert";
import maskEmailAddress from "utils/maskData";
import useAccessPinStatus from "hooks/useAccessPinStatus";
import * as walletAction from "store/entities/wallet/action";
import useInlinePageRouter from "components/__new/general/useInlinePageRouter";
import RecurringTransferSetup from "components/__new/payments/recurring-transfers/create/RecurringTransferSetup";
import RecurringTransfersTable from "components/__new/payments/recurring-transfers/RecurringTransfersTable";
import { getAllRecurringTransfers } from "store/entities/transfers/action";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import processParams from "utils/processParams";
import { useLocation } from "react-router-dom";
import RecurringTransferEdit from "components/__new/payments/recurring-transfers/edit/RecurringTransferEdit";


export const RecurringTransfers = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const {getAccessPinStatus} = useAccessPinStatus();
    const [editModalOpen, setEditModalOpen] = useState(false);
    
    const {urlQueryParams} = useUrlQueryParams();
    const { InlineRouterTab } = useInlinePageRouter();
    const {userInfo, updateIsAccessPinSet} = useLoginInfo();
    const { dashboardLoading, dashboard, otpGenerationLoading, otpGeneration, accessPinLoading, accessPin, walletTransferLoading, walletTransfer } = useSelector((s) => s.entities.wallet);    
    
    const [isOpenOtpNewPin, setIsOpenOtpNewPin] = useState(false);
    const [isOpenAccessPin, setIsOpenAccessPin] = useState(false);
    const [isOpenNewAccessPin, setIsOpenNewAccessPin] = useState(false);
    
    const [isOpenConfirmAccessPin, setIsOpenConfirmAccessPin] = useState(false);
    const [isOpenModalAlertTransferSuccess, setIsOpenModalAlertTransferSuccess] = useState(false);
    const [isOpenModalAlertNewPinSuccess, setIsOpenModalAlertNewPinSuccess] = useState(false);
    
    const [isRecurringDetailsOpen, setIsRecurringDetailsOpen] = useState(false);
    const toggleRecurringTransferSetup = () => setIsRecurringDetailsOpen(!isRecurringDetailsOpen);
    const toggleEditModal = () => setEditModalOpen(!editModalOpen)
    
    const [pin, setPin] = useState({
        otp: "",
        accessPin: "",
        accessPinConfirm: "",
    })
    
    const [listParams, setListParams] = useState({
        "page": 1,
        "limit": 20,
    });


    const getDashboard = () => {
        if(!dashboardLoading && (Object.keys(dashboard).length === 0 || dashboard.status !== "success")){
            dispatch(walletAction.getDashboardSilent(userInfo.token));
        }
    }

    const resetPins = () => {
        setPin({ ...pin, otp: "", accessPin: "", accessPinConfirm: "" });
    }
    
        
    const getRecurringTransfers = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 20, "limit");
        params = processParams(urlQueryParams, params, "keyword", "string", "", "keyword");
        params = processParams(urlQueryParams, params, "status", "string", "", "status");
        params = processParams(urlQueryParams, params, "dateRange", "string", "", "dateRange");
        params = processParams(urlQueryParams, params, "frequency", "string", "", "frequency");
        params = processParams(urlQueryParams, params, "startDate", "string", "", "startDate");
        params = processParams(urlQueryParams, params, "endDate", "string", "", "endDate");

        setListParams(params);
        dispatch(getAllRecurringTransfers(params));
    }

    useEffect(() => {
        getRecurringTransfers();
        // eslint-disable-next-line
    }, [location]);
    
    useEffect(() => {
        getDashboard();
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        // if (otpGeneration?.status === "success"){
        if (otpGeneration?.error === false){
            const hasAccessPin = getAccessPinStatus(dashboard);
            if (hasAccessPin === null || hasAccessPin === false){
                setIsOpenConfirmAccessPin(false);
                setIsOpenOtpNewPin(true);
            }
            dispatch(walletAction.generateOtpReset());
        }
        // eslint-disable-next-line
    }, [otpGeneration])


    useEffect(() => {
        if (accessPin?.status === "success"){
            setIsOpenOtpNewPin(false);
            setIsOpenModalAlertNewPinSuccess(true);
            resetPins();
            dispatch(walletAction.createAccessPinReset());
            dispatch(walletAction.getDashboard(userInfo));
            // updateIsAccessPinSet(true);
        }
        // eslint-disable-next-line
    }, [accessPin])


    useEffect(() => {
        if (walletTransfer?.status === "success"){
            setIsOpenAccessPin(false);
            setIsOpenModalAlertTransferSuccess(true);
            dispatch(walletAction.walletTransferReset());
        }
        else if (walletTransfer?.status === "failed"){
            setIsOpenAccessPin(false);
            dispatch(walletAction.walletTransferReset());
        }
        else if (walletTransfer?.status === "pending"){
            toast.error(walletTransfer?.message);
            setIsOpenAccessPin(false);
            dispatch(walletAction.walletTransferReset());
        }
        // eslint-disable-next-line
    }, [walletTransfer])
    

    return (
        <div>

            <DynamicHeadTag
                headerText="Recurring Transfers"
            />
            
            <RecurringTransferSetup
                isOpen={isRecurringDetailsOpen}
                getRecurringTransfers={getRecurringTransfers}
                toggleRecurringTransferSetup={toggleRecurringTransferSetup}
            />
            
            <RecurringTransferEdit
                isOpen={editModalOpen}
                toggleEditModal={toggleEditModal}
                getRecurringTransfers={getRecurringTransfers}
                toggleRecurringTransferSetup={toggleRecurringTransferSetup}
            />
        
            <div className="w-full lg:w-1/2 mb-5">
                <div className="page-title flex">
                    Transfers
                </div>
            </div>
            
            <div className="flex items-center justify-between w-full">
                <InlineRouterTab 
                    items={[
                        {
                            title: "Instant Transfers",
                            path: "/payments/transfers/instant-transfers"
                        },
                        {
                            title: "Recurring Transfers",
                            path: "/payments/transfers/recurring-transfers"
                        }
                    ]}
                />
            </div>
            
            <Maybe condition={dashboardLoading === false && dashboard?.status === "success"}>
                <>
                    <PinModal
                        target="Access Pin"
                        title="Validate Transfer"
                        description="Enter Access Pin"
                        pin={(e) => setPin({...pin, accessPin: e})}
                        submit={() => {}}
                        loading={walletTransferLoading}
                        modalLoading={dashboardLoading}
                        isOpenPin={isOpenAccessPin}
                        setIsOpenPin={setIsOpenAccessPin}
                        showForgotPin={true}
                    />


                    <ModalAlert
                        successText="Transaction successful"
                        dismissText="Send Another"
                        isOpenModalAlert={isOpenModalAlertTransferSuccess}
                        setIsOpenModalAlert={setIsOpenModalAlertTransferSuccess}
                    />


                    <PinModal
                        target="Access Pin"
                        title="Create Access Pin"
                        description="Set new access pin"
                        pin={(e) => setPin({...pin, accessPin: e})}
                        submit={() => {
                            setIsOpenNewAccessPin(false);
                            setIsOpenConfirmAccessPin(true);
                        }}
                        loading={false}
                        modalLoading={dashboardLoading}
                        isOpenPin={isOpenNewAccessPin}
                        setIsOpenPin={setIsOpenNewAccessPin}
                    />


                    <PinModal
                        target="Access Pin"
                        title="Confirm Access Pin"
                        description="Please re-enter your access pin"
                        pin={(e) => setPin({...pin, accessPinConfirm: e})}
                        submit={() => {
                            if (pin.accessPin === pin.accessPinConfirm){
                                if (userInfo.employer.userType === "employer"){
                                    dispatch(walletAction.generateOtp(userInfo.token, "access-pin"));
                                }
                                else if (userInfo.employer.userType === "employer-admin" || userInfo.employer.userType === "employer-business-member"){
                                    dispatch(walletAction.generateOtpEmployerAdmin(null, 'access-pin'));
                                }
                            }
                            else{
                                toast.error("Your access pin does not match");
                            }
                        }}
                        loading={otpGenerationLoading}
                        modalLoading={dashboardLoading}
                        isOpenPin={isOpenConfirmAccessPin}
                        setIsOpenPin={setIsOpenConfirmAccessPin}
                    />


                    <PinModal
                        target="OTP"
                        title="Enter OTP"
                        description={"Enter OTP sent to " + maskEmailAddress(userInfo?.member?.email) + ", to create your new access pin"}
                        pin={(e) => setPin({...pin, otp: e})}
                        submit={() => {
                            const params = {otp: parseInt(pin.otp), accessPin: pin.accessPin}
                            if (userInfo.employer.userType === "employer"){
                                dispatch(walletAction.createAccessPin(userInfo.token, params));
                            }
                            else if (userInfo.employer.userType === "employer-admin" || userInfo.employer.userType === "employer-business-member"){
                                dispatch(walletAction.createAccessPinEmployerAdmin(params));
                            }
                        }}
                        loading={accessPinLoading}
                        modalLoading={otpGenerationLoading}
                        isOpenPin={isOpenOtpNewPin}
                        setIsOpenPin={setIsOpenOtpNewPin}
                    />


                    <ModalAlert
                        successText="Access Pin created successfully"
                        dismissText="Back to transfer"
                        isOpenModalAlert={isOpenModalAlertNewPinSuccess}
                        setIsOpenModalAlert={setIsOpenModalAlertNewPinSuccess}
                        submit={() => {
                            setIsOpenModalAlertNewPinSuccess(false);
                            setIsOpenAccessPin(true);
                        }}
                    />
                </>
            </Maybe>

            <RecurringTransfersTable
                toggleEditModal={toggleEditModal}
                getRecurringTransfers={getRecurringTransfers}
                toggleRecurringTransferSetup={toggleRecurringTransferSetup}
            />

        </div>
    )
}

export default RecurringTransfers;